import { render, staticRenderFns } from "./ModalApproval.vue?vue&type=template&id=4044345b&"
import script from "./ModalApproval.vue?vue&type=script&lang=js&"
export * from "./ModalApproval.vue?vue&type=script&lang=js&"
import style0 from "./ModalApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports